module.exports = __webpack_public_path__ + "static/media/csvFile.eb712cdd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_assets/icons/csvFile.svg
// module id = 728
// module chunks = 0